import{__assign as o}from'../../dependencies/tslib/tslib.es6.js';var r={borderRadius:10},s=function(s){r=o(o({},r),s)};export{s as initializeShape,r as shape};
